import { error, finish } from '../../../modules/system-settings/actions/put-cashout-settings';
import api from '../../../api';

export function request(dispatch, { data }) {

    api.put(`/cashout/settings`, data ).then(
        response => dispatch(finish( data )),
        (errors) => dispatch(error(errors))
    );
}
